import React from 'react';
import type { Customer, Order } from '../../types';
import CustomerManagementPage from '../../pages/CustomerManagementPage';

interface PosCustomerManagementOverlayProps {
  onClose: () => void;
  customers: Customer[];
  orders: Order[];
  onSave: (customer: Customer) => void;
  onDelete: (customerId: number) => void;
}

const PosCustomerManagementOverlay: React.FC<PosCustomerManagementOverlayProps> = ({
  onClose,
  customers,
  orders,
  onSave,
  onDelete,
}) => {
  return (
    <div className="fixed inset-0 z-[80] flex flex-col bg-white">
      <div className="flex items-center justify-between gap-3 px-4 py-3 border-b border-gray-200 bg-white shrink-0 shadow-sm">
        <h2 className="text-lg font-bold text-gray-900">Customer Management</h2>
        <button
          type="button"
          onClick={onClose}
          className="px-4 py-2 text-sm font-bold rounded-md bg-gray-100 text-gray-800 hover:bg-gray-200 transition-colors"
        >
          Close
        </button>
      </div>
      <div className="flex-1 min-h-0 overflow-auto">
        <CustomerManagementPage
          customers={customers}
          orders={orders}
          onSave={onSave}
          onDelete={onDelete}
        />
      </div>
    </div>
  );
};

export default PosCustomerManagementOverlay;
